const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row footer-main">
          <div className="col-xl-12 col-sm-12">
            <h4 className="agent-name">AMBERWOOD REAL ESTATE INC.</h4>
          </div>
          <div className="col-xl-12 col-sm-12">
            <div className="agent-details">
              <div className="details-box">
                <h5>ROSANNE ROJO</h5>
                <p>DRE #01755826</p>
              </div>
              <div className="details-box">
                <h5>EMAIL ADDRESS</h5>
                <a href="mailto:rosannemrojo@gmail.com">
                  rosannemrojo@gmail.com
                </a>
              </div>
              <div className="details-box">
                <h5>PHONE</h5>
                <a href="tel:+17143311826">(714) 331-1826</a>
              </div>
              <div className="details-box">
                <h5>ADDRESS</h5>
                <a
                  href="https://goo.gl/maps/dGB7bR1pBhzRCYjX6"
                  target="_blank"
                  rel="noreferrer"
                >
                  11060 Artesia Blvd Suite G, Cerritos, CA 90703
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-12 col-sm-12">
            <p className="footer-small-info">
              Rosanne Rojo is a real estate agent licensed by the state of
              California affiliated with Amberwood Real Estate. Rosanne Rojo is
              a real estate agent licensed by the state of California and abides
              by equal housing opportunity laws. All material presented herein
              is intended for informational purposes only. Information is
              compiled from sources deemed reliable but is subject to errors,
              omissions, changes in price, condition, sale, or withdrawal
              without notice. No statement is made as to accuracy of any
              description. All measurements and square footages are approximate.
              This is not intended to solicit property already listed. Nothing
              herein shall be construed as legal, accounting or other
              professional advice outside the realm of real estate brokerage.
            </p>
          </div>
        </div>
        <div className="copyright-main">
          <h5>
            © 2026, ROSANNE ROJO. POWERED BY{" "}
            <a
              href="https://www.roundtechsquare.com"
              target="_blank"
              rel="noreferrer"
            >
              ROUNDTECHSQUARE
            </a>
          </h5>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
